module.exports = __webpack_public_path__ + "static/GINE_SR-e885f8e4beeefbdb4f93cedecc5b185b.png";